import { render, staticRenderFns } from "./TimesCardPriceForm.vue?vue&type=template&id=04357a10&scoped=true&"
import script from "./TimesCardPriceForm.vue?vue&type=script&lang=js&"
export * from "./TimesCardPriceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04357a10",
  null
  
)

export default component.exports